import { isQuestCopyEditorOrQuestAuthor } from './user'

export function questIsAssignedToUser(quest, user) {
  return Boolean(quest.assigned_to) && quest.assigned_to.id === user.id
}

export function questIsAssignedByUser(quest, user) {
  return Boolean(quest.assigned_by) && quest.assigned_by.id === user.id
}

export function userCanViewAssignmentMessage(user, quest, organization) {
  return (
    isQuestCopyEditorOrQuestAuthor(user, quest, organization) ||
    questIsAssignedToUser(quest, user) ||
    questIsAssignedByUser(quest, user)
  )
}

export function questHasAssignment(quest) {
  return Boolean(quest.assigned_by)
}



// WEBPACK FOOTER //
// ./src/utils/assignment.js